import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// DRUG_LIST_UPDATE_UPLOAD_ATTACHMENT

const mutation = gql`
  mutation drugListUpdateRequestUploadAttachment(
    $id: ID!
    $attachment: DrugListUpdateRequestAttachmentInput!
  ) {
    drugListUpdateRequestUploadAttachment(
      form_id: $id
      attachment: $attachment
    ) {
      id
      form_attachment {
        id
      }
    }
  }
`
export default function useDrugListUpdateRequestUploadAttachment() {
  const { onMutate: onDrugListUpdateRequestAttachmentUpload, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'drugListUpdateRequestUploadAttachment',
      successMessage: 'Attachment uploaded'
    })

  return { onDrugListUpdateRequestAttachmentUpload, loading }
}
